import React from "react";
import { SlidersHorizontal } from "lucide-react";
import "./sidebar.css";

export default function MobileFilters({ filters, onFilterChange }) {
  
  // 1. Check if filters are active (Budget < 20k OR Rating selected OR Amenities selected)
  const isFilterActive = 
    filters.maxBudget < 20000 || 
    filters.rating !== "any" || 
    (filters.amenities && filters.amenities.length > 0);

  // 2. Reset Handler
  const handleReset = () => {
    onFilterChange("maxBudget", 20000);
    onFilterChange("rating", "any");
    onFilterChange("amenities", []);
  };

  return (
    <div className="mobile-filters-wrapper">
      
      {/* Header with Conditional Reset Button */}
      <div className="mobile-filters-header">
        <div className="flex items-center gap-2">
          <SlidersHorizontal size={15} />
          <span>Filters</span>
        </div>

        {isFilterActive && (
          <button onClick={handleReset} className="reset-text-btn">
            Reset
          </button>
        )}
      </div>

      {/* Scrollable row */}
      <div className="mobile-filters-row">

        {/* Budget Card - Redesigned to be smaller */}
        <div className="mobile-filter-card budget-card">
          <div className="budget-header">
             <span className="label">Max Budget</span>
             <span className="value">AED {filters.maxBudget.toLocaleString()}</span>
          </div>
          <input
            type="range"
            min="500"
            max="20000"
            step="500"
            value={filters.maxBudget}
            onChange={(e) =>
              onFilterChange("maxBudget", Number(e.target.value))
            }
          />
        </div>

        {/* Rating Chips */}
        {[9, 8].map((score) => (
          <button
            key={score}
            className={`mobile-chip ${
              filters.rating === String(score) ? "active" : ""
            }`}
            onClick={() =>
              onFilterChange(
                "rating",
                filters.rating === String(score) ? "any" : String(score)
              )
            }
          >
            {score}+ Star
          </button>
        ))}

        {/* Amenities Chips */}
        {["Pool", "WiFi", "Parking", "Gym"].map((item) => (
          <button
            key={item}
            className={`mobile-chip ${
              filters.amenities.includes(item) ? "active" : ""
            }`}
            onClick={() => {
              const exists = filters.amenities.includes(item);
              onFilterChange(
                "amenities",
                exists
                  ? filters.amenities.filter((a) => a !== item)
                  : [...filters.amenities, item]
              );
            }}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );
}